import { Grid } from "@mui/material";
import Title from "../../../libs/rhf-mui/ui/Title";
import UcTitle from "../../components/uni/UcTitle";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { Is連動排除的題目, UniQuestion } from "../../dao/UniQuestion";
import UcCustom from "./UcCustom";
import UcPicture from "./UcPicture";
import UcQuestion from "./UcQuestion";
import { useFormContext } from "react-hook-form";
import { useGV } from "../../GV";
import { Member } from "../../dao/Member";

type Props = {
  questions: UniQuestion[] | undefined;
  member: Member | null | undefined;
  LangA: Lang;
  LangB: Lang;
};

const UcQuestionPanel = ({
  questions,
  member,
  LangA,
  LangB,
  ...props
}: Props) => {
  const GV = useGV();
  const rhf = useFormContext();

  function render_OneQuestion(question: UniQuestion) {
    let is_lock = Is連動排除的題目(question, rhf); // 是否 Hide 或 Disabled 這題

    let bg_color = undefined;
    if (is_lock === true) {
      // 隱藏題目
      if (GV.IsAdmin() === true) {
        bg_color = "#FFAAAA"; // red 後台塗成紅色
      } else {
        return undefined; // 前台隱藏
      }
    } else {
      // pass; 一般題目，總是往下 render 題目
    }

    if (
      question.kind === SpwkUtil.KIND_單選 ||
      question.kind === SpwkUtil.KIND_多選 ||
      question.kind === SpwkUtil.KIND_非選
    ) {
      // 未來可能不只是 UcQuestion
      return (
        <Grid
          key={question.guid}
          item
          xs={12}
          sx={{ py: 0, bgcolor: bg_color }}
        >
          <UcQuestion
            key={question.guid}
            question={question}
            member={member}
            LangA={LangA}
            LangB={LangB}
          />
        </Grid>
      );
    } else if (question.kind === SpwkUtil.KIND_標題) {
      return (
        <Grid
          key={question.guid}
          item
          xs={12}
          sx={{ py: 0, bgcolor: bg_color }}
        >
          <UcTitle
            key={question.guid}
            question={question}
            LangA={LangA}
            LangB={LangB}
          />
        </Grid>
      );
    } else if (question.kind === SpwkUtil.KIND_圖片) {
      return (
        <Grid
          key={question.guid}
          item
          xs={12}
          sx={{ py: 0, bgcolor: bg_color }}
        >
          <UcPicture key={question.guid} question={question} />
        </Grid>
      );
    } else if (question.kind === SpwkUtil.KIND_自訂) {
      return (
        <Grid
          key={question.guid}
          item
          xs={12}
          sx={{ py: 0, bgcolor: bg_color }}
        >
          <UcCustom key={question.guid} question={question} />
        </Grid>
      );
    } else {
      return (
        <Grid key={question.guid} item xs={12}>
          <Title
            key={question.guid}
            variant="subtitle2"
            color="red"
            bgcolor={"yellow"}
          >
            {"{KIND: " + question.kind + ", ID:" + question.serno + "}"}
          </Title>
        </Grid>
      );
    }
  }

  return <Grid container>{questions?.map((q) => render_OneQuestion(q))}</Grid>;
};

export default UcQuestionPanel;
